import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as mammoth from 'mammoth';
@Component({
  selector: 'app-privacidad',
  templateUrl: './privacidad.component.html',
  styleUrls: ['./privacidad.component.scss']
})
export class PrivacidadComponent implements OnInit {
  title = 'Aviso de privacidad del Sorteo Anáhuac 2026';
  description = 'Consulta el aviso de privacidad y cómo tratamos los datos personales de los usuarios del sitio de Sorteo Anáhuac Onceava Edición.';
  
  // Variable para almacenar el HTML seguro generado desde el Word
  htmlContent: SafeHtml = '';

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) { }
 
  ngOnInit(): void {
    // 1. Configuración de SEO y Meta Tags
    this.titleService.setTitle(this.title);
    this.metaTagService.updateTag({ name: 'title', content: this.title });
    this.metaTagService.updateTag({ name: 'description', content: this.description });
    this.metaTagService.updateTag({ property: 'keywords', content: 'Nosotros' });
    this.metaTagService.updateTag({ property: 'og:title', content: this.title });
    this.metaTagService.updateTag({ property: 'og:description', content: this.description });
    this.metaTagService.updateTag({ property: 'og:url', content: environment.URL_WEB + '/nosotros' });
    this.metaTagService.updateTag({ property: 'og:image', content: environment.URL_WEB + '/assets/images/banner2_about.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: this.title });
    this.metaTagService.updateTag({ name: 'twitter:description', content: this.description });

    // 2. Disparar la lectura y conversión del documento Word
    this.cargarAvisoPrivacidad();
  }

  cargarAvisoPrivacidad(): void {
    // Ruta hacia tu archivo en la carpeta assets
    const url = '/assets/docs/aviso-privacidad.docx'; 

    this.http.get(url, { responseType: 'arraybuffer' }).subscribe({
      next: (arrayBuffer: ArrayBuffer) => {
        mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
          .then((result) => {
            // Sanitizamos el HTML generado para inyectarlo de forma segura en la vista
            this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(result.value);
            
            if (result.messages.length > 0) {
              console.warn('Mensajes de Mammoth:', result.messages);
            }
          })
          .catch((error) => {
            console.error('Error al convertir el documento Word:', error);
          });
      },
      error: (error) => {
        console.error('Error al cargar el archivo de assets:', error);
      }
    });
  }
}